<template>
  <omint-page>
    <Header name="Ouvidoria" titleLabel="Ouvidoria" />
    <router-view />
    <Footer />
  </omint-page>
</template>

<script>
import Header from "@/components/Molecules/Header";
import Footer from "@/components/Molecules/Footer";

export default {
  name: "Ouvidoria",
  components: {
    Header,
    Footer
  }
};
</script>
